import icons from './packages/svg';

export default {
    name: 'SaIcon',
    props: {
        name: {
            // name: common-icon-border-export
            type: String,
            required: true
        },
        version: {
            type: String,
            default: 'v1'
        },
        config: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {}
    },
    computed: {
        className() {
            if (!this.name) {
                return '';
            }
            // 有空格，判定为class
            if (this.name.indexOf(' ') > -1) {
                return this.name;
            }
            const [cate, name] = this.name.split('-icon-');
            return [`${cate}-icon`, `icon-${name}`];
        }
    },
    render(h) {
        if (this.version === 'v2') {
            const cur = icons.find((item) => {
                return item.name === this.name
            });
            if (cur) {
                return h('i', {
                    domProps: {
                        innerHTML: cur.render(this.config)
                    }
                }, [])
            }
            console.log(`[sa-icon v2] ${this.name}未找到`)
            return '';
        }
        return (<i class={this.className}></i>);
    }
}
